import React, { useCallback } from 'react';
import { Drawer, Input } from 'antd';
import PropTypes from 'prop-types';
import DrawerSubmitFooter from '../../../common/containers/DrawerSubmitFooter';
import { FOOTER_HEIGHT } from '../../../constants/Styles';

export default function TableAddDrawer({
  title,
  searchStr,
  onSearch,
  children,
  visible,
  onClose,
  onSubmit,
  showFooter = true,
  bodyStyle = {},
  destroyOnClose = false,
  width = 600,
  zIndex,
}) {
  const onSearchChanged = useCallback((e) => {
    const {
      target: {
        value,
      } = {},
    } = e;
    onSearch(value);
  }, []);

  return (
    <Drawer
      title={title}
      visible={visible}
      width={width}
      onClose={onClose}
      destroyOnClose={destroyOnClose}
      zIndex={zIndex}
    >
      <Input.Search
        type='search'
        style={{ width:'100%' }}
        className='searchbar'
        placeholder='Search'
        allowClear
        onChange={onSearchChanged}
        value={searchStr}
      />
      <div className='table-add-scroll' style={{ bottom: showFooter ? FOOTER_HEIGHT : 0, ...bodyStyle }}>
        {children}
      </div>
      {showFooter && <DrawerSubmitFooter
        onClose={onClose}
        onSubmit={onSubmit}
      />}
    </Drawer>
  )
}

TableAddDrawer.propTypes = {
  title: PropTypes.string.isRequired,
  searchStr: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  showFooter: PropTypes.bool,
  bodyStyle: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  destroyOnClose: PropTypes.bool,
  width: PropTypes.number,
};
